'use strict';

angular.module('shiftTraderApp')
  .factory('OrganizationSettings', function (ServerUrls, $http, $q) {
    var path = ServerUrls.current.railsApi + 'organization_configs/';

    var OrganizationSettings = {};

    /**
     * userId and orgId can be left off if they are included in the correct format in
     * the options object. @see OrganizationSettings.update()
     *
     * @param {Object} options (required)
     * @param {int} orgId
     * @returns {Promise} of updated settings
     */

    OrganizationSettings.updateByOrgId = function (options, orgId) {
      var organization_config = {
        organization_id: orgId
      };
      angular.extend(organization_config, options);

      var data = {
        organization_config: organization_config
      };

      return $http.put(path, data).then(function (response) {
        return response.data;
      }, function(response) {
        return $q.reject(response);
      });

    };

    OrganizationSettings.update = function (options, org_id) {
      return OrganizationSettings.updateByOrgId(options, org_id);
    };

    OrganizationSettings.create = function(options) {
      return $http.post(path, options)
        .then(function(response) {
          return response.data;
        }, function(response) {
          return $q.reject(response);
        });
    };


    return OrganizationSettings;
  });
